/* ===========================================================
   FUNGOVIA — theme.js
   Ported from the static build's funnel.js. The behaviour is the same; the
   data is not. Prices, variants and cart state now come from Shopify rather
   than from a hardcoded object in the script, so nothing here has to be kept
   in sync with the product by hand.
   =========================================================== */

(function () {
  'use strict';

  var CFG = window.FV || {};

  /* ---------------------------------------------------------- money ---- */
  // Mirrors Shopify's money filter for the client-rendered totals (bundle
  // switch, bump toggle) so a price never changes format mid-page.
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, parts.join('.'));
  }

  /* ------------------------------------------------------ countdown ---- */
  // The deadline is stored per visitor. A timer that restarts on every page
  // load is visibly fake to anyone who refreshes, and it is the kind of thing
  // ad platforms flag. This one runs down once and stays down.
  function initCountdown() {
    var el = document.querySelector('[data-countdown]');
    if (!el) return;
    var hours = Number(CFG.countdownHours || 3);
    var key = 'fv_deadline';
    var deadline;
    try {
      deadline = Number(localStorage.getItem(key));
      if (!deadline || isNaN(deadline) || deadline < Date.now()) {
        deadline = Date.now() + hours * 3600 * 1000;
        localStorage.setItem(key, String(deadline));
      }
    } catch (e) {
      deadline = Date.now() + hours * 3600 * 1000;
    }
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var s = Math.max(0, Math.floor((deadline - Date.now()) / 1000));
      el.textContent = pad(Math.floor(s / 3600)) + ' Hrs ' +
                       pad(Math.floor((s % 3600) / 60)) + ' Mins ' +
                       pad(s % 60) + ' Secs';
    };
    tick();
    setInterval(tick, 1000);
  }

  /* --------------------------------------------------- scroll reveal ---- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal,.reveal-l,.reveal-r');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------- counters ---- */
  function initCounters() {
    var els = document.querySelectorAll('[data-count]');
    var run = function (el) {
      var target = parseFloat(el.dataset.count);
      var suffix = el.dataset.suffix || '%';
      var dur = 1500, t0 = performance.now();
      var step = function (now) {
        var p = Math.min((now - t0) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3); // easeOutCubic
        el.textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    };
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) {
      e.textContent = '0' + (e.dataset.suffix || '%');
      io.observe(e);
    });
  }

  /* ------------------------------------------------------ stock bar ---- */
  function initBars() {
    var els = document.querySelectorAll('.stock');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ------------------------------------------------------ carousels ---- */
  function initCarousels() {
    document.querySelectorAll('.car').forEach(function (car) {
      var track = car.querySelector('.car-track');
      if (!track || track.dataset.bound) return;
      track.dataset.bound = '1';
      var prev = car.querySelector('[data-prev]');
      var next = car.querySelector('[data-next]');
      var dots = car.querySelector('.car-dots');
      var slides = Array.prototype.slice.call(track.children);

      var perPage = function () {
        var w = slides[0] ? slides[0].getBoundingClientRect().width + 20 : 1;
        return Math.max(1, Math.round(track.clientWidth / w));
      };
      var pages = function () { return Math.max(1, Math.ceil(slides.length / perPage())); };

      if (dots) {
        dots.innerHTML = '';
        for (var i = 0; i < pages(); i++) {
          (function (i) {
            var b = document.createElement('button');
            b.className = 'car-dot' + (i ? '' : ' on');
            b.type = 'button';
            b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
            b.onclick = function () { track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); };
            dots.appendChild(b);
          })(i);
        }
      }
      var upd = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (dots) {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          Array.prototype.forEach.call(dots.children, function (d, j) { d.classList.toggle('on', j === i); });
        }
      };
      if (prev) prev.onclick = function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); };
      if (next) next.onclick = function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); };
      track.addEventListener('scroll', function () {
        clearTimeout(track._t);
        track._t = setTimeout(upd, 70);
      }, { passive: true });
      window.addEventListener('resize', upd);
      upd();
    });
  }

  /* ------------------------------------------------------ sticky ATC ---- */
  // Observe the CTA BUTTON itself, not the section wrapper. The bar must appear
  // the moment the real Add To Cart leaves the viewport and hide again when it
  // returns. Observing the tall wrapper left a ~1300px stretch of the page with
  // no buy button on screen at all.
  function initStickyBar() {
    var bar = document.getElementById('sticky');
    var anchor = document.querySelector('[data-atc-anchor]');
    if (!bar || !anchor || bar.dataset.bound) return;
    bar.dataset.bound = '1';

    // Reserve space so the fixed bar never covers the last row of content. Pad
    // the FOOTER, not <body>: body is white and the footer is dark, so body
    // padding leaves a white strip under the footer.
    var host = document.querySelector('.site-footer') || document.body;
    var basePad = parseFloat(getComputedStyle(host).paddingBottom) || 0;
    var pad = function () { host.style.paddingBottom = (basePad + bar.offsetHeight) + 'px'; };
    pad();
    window.addEventListener('resize', pad);

    var shown = null;
    var set = function (v) { if (v !== shown) { shown = v; bar.classList.toggle('show', v); } };

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        set(!e.isIntersecting && e.boundingClientRect.top < 0);
      }, { threshold: 0 }).observe(anchor);
    }

    // Safety net: a rAF-throttled scroll check keeps the state correct through
    // fast scrolls, anchor resizes (switching bundle changes button height) and
    // hash jumps, all of which the observer alone can miss.
    var ticking = false;
    var check = function () { ticking = false; set(anchor.getBoundingClientRect().bottom < 0); };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(check); }
    }, { passive: true });
    check();
  }

  /* ---------------------------------------------------------- gallery -- */
  function initGallery() {
    var gal = document.querySelector('[data-gallery]');
    if (!gal || gal.dataset.bound) return;
    gal.dataset.bound = '1';
    var hero = gal.querySelector('[data-gallery-hero]');
    gal.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!hero) return;
        hero.src = thumb.dataset.full || thumb.src;
        hero.alt = thumb.alt || '';
        gal.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
      });
    });
  }

  /* ------------------------------------------------- product buy box ---- */
  // Bundle tiers are real variants. Selecting one sets the form's variant id,
  // repaints every price on the page and keeps the sticky bar in step. The
  // order bumps are separate products added as their own line items, which is
  // what makes them appear correctly in the order and stay refundable alone.
  function initBuyBox() {
    var form = document.querySelector('[data-buy-form]');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = '1';

    var idInput = form.querySelector('[name="id"]');
    var tiers = Array.prototype.slice.call(document.querySelectorAll('[data-tier]'));
    var bumps = Array.prototype.slice.call(document.querySelectorAll('[data-bump]'));

    var current = function () {
      return tiers.filter(function (t) { return t.classList.contains('on'); })[0] || tiers[0];
    };

    var setAll = function (sel, text) {
      document.querySelectorAll(sel).forEach(function (el) { el.textContent = text; });
    };

    var repaint = function () {
      var t = current();
      if (!t) return;
      var price = Number(t.dataset.price || 0);
      var compare = Number(t.dataset.compare || 0);
      var total = price;
      bumps.forEach(function (b) {
        var cb = b.querySelector('input[type="checkbox"]');
        if (cb && cb.checked) total += Number(b.dataset.price || 0);
      });

      setAll('[data-price-now]', money(price));
      setAll('[data-price-was]', compare > price ? money(compare) : '');
      setAll('[data-atc-total]', money(total));
      setAll('[data-atc-was]', compare > price ? money(compare) : '');
      setAll('[data-sticky-name]', t.dataset.name || '');
      if (compare > price) {
        var pct = Math.round((1 - price / compare) * 100);
        setAll('[data-save-pct]', 'Save ' + pct + '%');
        setAll('[data-sticky-price]', money(price) + ' · Save ' + money(compare - price));
      } else {
        setAll('[data-save-pct]', '');
        setAll('[data-sticky-price]', money(price));
      }
      if (idInput) idInput.value = t.dataset.variant || '';
    };

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) {
          x.classList.remove('on');
          x.setAttribute('aria-checked', 'false');
        });
        t.classList.add('on');
        t.setAttribute('aria-checked', 'true');
        repaint();
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
      });
    });
    bumps.forEach(function (b) {
      var cb = b.querySelector('input[type="checkbox"]');
      if (cb) cb.addEventListener('change', repaint);
    });

    // The bumps are added after the main line item so the cart reads in the
    // order the customer built it. Failures surface rather than being swallowed:
    // silently landing on the cart without the bump they ticked is worse than
    // an error message.
    form.addEventListener('submit', function (e) {
      var wanted = bumps.filter(function (b) {
        var cb = b.querySelector('input[type="checkbox"]');
        return cb && cb.checked && b.dataset.variant;
      });
      if (!wanted.length) return; // no bumps: let the plain form post through

      e.preventDefault();
      var btn = form.querySelector('[data-atc-button]');
      if (btn) { btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }

      var items = [{ id: Number(idInput.value), quantity: 1 }];
      wanted.forEach(function (b) { items.push({ id: Number(b.dataset.variant), quantity: 1 }); });

      fetch(CFG.cartAddUrl || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || 'Could not add to cart');
          window.location.href = CFG.cartUrl || '/cart';
        })
        .catch(function (err) {
          if (btn) { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); }
          var msg = form.querySelector('[data-cart-error]');
          if (msg) { msg.textContent = err.message; msg.hidden = false; }
          else form.submit();
        });
    });

    repaint();
  }

  /* ------------------------------------------------------------ boot ---- */
  function boot() {
    initCountdown();
    initReveal();
    initCounters();
    initBars();
    initCarousels();
    initStickyBar();
    initGallery();
    initBuyBox();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // The theme editor tears down and re-renders a section on every change, which
  // strips the observers and listeners bound above. Rebinding on these events is
  // what stops the editor preview going dead after the first edit. The
  // dataset.bound guards keep the rebind from double-binding untouched sections.
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:select', boot);
})();
